export default __webpack_public_path__ + "static/assets/aa27762928c1dc3a126c4320b48c689a.png";